module.exports = {"540237100":"岗巴镇","540237200":"昌龙乡","540237201":"直克乡","540237202":"孔玛乡","540237203":"龙中乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540237.json
// module id = 2840
// module chunks = 0